// src/pages/Instructions.js
import React from "react";
import Accordion from "react-bootstrap/Accordion";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";

import "bootstrap/dist/css/bootstrap.min.css";

const Instructions = () => {
  return (
    <Container className="mt-4">
      <h2 className="mb-4">Інструкції та інформація</h2>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>1. Що обов'язвово потрібно знати і розуміти</Accordion.Header>
          <Accordion.Body>
          1.1  Дуже важливо розуміти, що майже всюди ключем є номер тижня. Тому потрібно завжди правильно обирати тиждень, де тільки це можливо. <br />
          1.2 На даний момент додаток працює добре у випадку, якщо все робити правильно. Якщо десь щось буде "не по шаблонам" які я прописав, щось може не працювати.<br />
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>2. Таблиці які ми завантажуємо у систему</Accordion.Header>
          <Accordion.Body>
            Я зробив підсвітку деяких полів (я називаю їх аномалії) у попередньому перегляді таблиці, яку ми завантажуємо. Умови для аномалій: <br /><br />
            <b>Uber</b> - якщо значення більше 3000 або менше -500<br />
            <b>Bolt</b> - якщо значення більше 3500<br /><br />
            Це зроблено для того, що б в додаток записувались правильні значення (дивитися 1.2). Аномалії в таблиці виглядають так:
            <Image src="/images/instructions/anomaly1.png" fluid className="mt-3" />
            <br /><br />
            Синім виділена аномалія виплати для партнера, але синім ми маємо аномалію, яка може призвести до проблем.<br />
            <h3>Що робити?</h3>
            Ці аномалії з'являються через неправильний формат комірки у файлі .XLS. У цьому випадку Excel вважає, що значення це дата, і записує комірку як число (місяць і рік). Потрібно відкрити таблицю і знайти цю комірку:<br />
            <Image src="/images/instructions/anomaly2.png" fluid className="mt-3" /><br /><br />
            Здається що тут все правильно, але якщо перевести комірку у числовий формат (як заплановано, (дивитися 1.2)), то ми отримаємо таке саме значення як на сторінці попереднього перегляду:
            <Image src="/images/instructions/anomaly3.png" fluid className="mt-3" /><br /><br />
            Що б в данному прикладі значення в таблиці було правильним потрібно в значення комірки вписати це значення з ' на початку:
            <Image src="/images/instructions/anomaly4.png" fluid className="mt-3" /><br /><br />
            В такому випадку значення в таблиці запишеться правильно (як число) і додаток правильно його запише в базу даних:
            <Image src="/images/instructions/anomaly5.png" fluid className="mt-3" /><br /><br />


          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>3. Рапорти готівка</Accordion.Header>
          <Accordion.Body>
            Ми не можемо зробити вибірку з першого до останнього дня місяця (дивитися 1.1), тому рапорти готівки можна сформувати лише для вибраних тижнів. <br />
            При генерації рапортів виводяться і сумуються значення брутто для Bolt.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default Instructions;
